import { dispatch } from '@rematch/core';
import {
    customTemplateActionService,
    activityActionsService,
    initiativeActivityActionsService
} from '../../services/feathers.service';
import { push } from "react-router-redux";

const initialState = {
    customNotificationArray: [],
    globalTemplate: {},
    customNotificationRuleName: "",
    customNotificationCondition: "",
    selectedTemplateUsed: false
};



export default {
    state: initialState,
    reducers: {
        setCustomNotificationArray(state, payload) {
            return {
                ...state,
                customNotificationArray: payload
            }
        },
        setCustomNotificationGlobalTemplate(state, payload) {
            return {
                ...state,
                globalTemplate: payload
            }
        },
        setCustomNotificationRuleName(state, payload) {
            return {
                ...state,
                customNotificationRuleName: payload
            }
        },
        setCustomNotificationCondition(state, payload) {
            return {
                ...state,
                customNotificationCondition: payload
            }
        },
        setSelectedTemplateUsed(state, payload) {
            return {
                ...state,
                selectedTemplateUsed: payload
            }
        },
    },
    effects: {
        async addGlobalTemplate(payload, state) {
            try {
                payload.name = state.app.selectedOrganisation.name;
                payload.accountId = state.app.selectedAccount._id;
                payload.organizationId = state.app.selectedOrganisation.id;
                payload.type = "globalHeader";
                let template = await customTemplateActionService.find({
                    "query": {
                        "accountId": payload.accountId,
                        "organizationId": payload.organizationId,
                        "type": "globalHeader"
                    }
                });
                if(template && template.data && template.data.length > 0){
                    await customTemplateActionService.patch(template.data[0]._id, payload);
                } else {
                    await customTemplateActionService.create(payload);
                }         
                return dispatch(push('/app/'+payload.accountId+'/_ws/'+payload.organizationId+'/_wsSetting/emailTemplates/listing'))
            } catch (error) {
                console.log("Error in adding global template ",error)
                throw error;
            }
        },
        async fetchGlobalTemplate(payload, state){
            try {
                let query = {};
                let data = {};
                query.accountId = state.app.selectedAccount._id;
                query.organizationId = state.app.selectedOrganisation.id;
                query.type = "globalHeader";
                let template = await customTemplateActionService.find({"query" : query});
                if(template && template.data && template.data.length > 0){
                    data = {
                        "header": template.data[0].header,
                        "footer": template.data[0].footer,
                        "signature": template.data[0].signature,
                        "fromEmail": template.data[0].fromEmail,
                        "picture": template.data[0].picture,
                        "type":template.data[0].type,
                        "_id":template.data[0]._id
                    }
                } else {
                    data = {
                        "header": state.app.selectedOrganisation.name,
                        "footer": "Please do not reply to this email.\nIn case you have any queries send email.",
                        "signature": "Thank you.",
                    }
                }
                dispatch.customTemplates.setCustomNotificationGlobalTemplate(data);
            } catch (error) {
                console.log("Error in fetching global template ",error)
                throw error;
            }           
        },
        async addEmailTemplate(payload, state){
            try {
                payload.accountId = state.app.selectedAccount._id;
                payload.organizationId = state.app.selectedOrganisation.id;
                payload.rule = JSON.parse(payload.rule);
                payload.type = "email";
                await customTemplateActionService.create(payload);
                return dispatch(push('/app/'+payload.accountId+'/_ws/'+payload.organizationId+'/_wsSetting/emailTemplates/listing')) 
            } catch (error) {
                console.log("Error in adding email template ",error)
                throw error;
            }
        },
        async fetchTemplates(payload, state){
            try {
                let query = {};
                query.accountId = state.app.selectedAccount._id;
                query.organizationId = state.app.selectedOrganisation.id;
                query.type = "email";
                let template = await customTemplateActionService.find({"query" : query});
                dispatch.customTemplates.setCustomNotificationArray(template);
                
            } catch (error) {
                console.log("Error in fetching email templates ",error)
                throw error;
            }
        },
        async fetchTemplateId(templateId, state){
            try {
                let template = await customTemplateActionService.get(templateId);
                dispatch.customTemplates.setCustomNotificationRuleName(template.name);
                dispatch.customTemplates.setCustomNotificationCondition(JSON.stringify(template.rule, null, 4));
            } catch (error) {
                console.log("Error in fetching template by id ",error)
                throw error;
            }
        },
        async updateEmailTemplate(templateObj, state){
            try {
                let data = {};
                data.accountId = state.app.selectedAccount._id;
                data.organizationId = state.app.selectedOrganisation.id;
                let templateId = templateObj.templateId;
                let dataToUpdate = templateObj.template;
                dataToUpdate.rule = JSON.parse(dataToUpdate.rule);
                let template = await customTemplateActionService.patch(templateId, dataToUpdate);
                return dispatch(push('/app/'+data.accountId+'/_ws/'+data.organizationId+'/_wsSetting/emailTemplates/listing')) 
            } catch (error) {
                console.log("Error in updating template by id ",error)
                throw error;
            }
        },
        async checkTemplateInUse(templateId, state){
            try {
                let templateUsed = await activityActionsService.find({"query":{"metaData.templateId": templateId}});
                if(templateUsed && templateUsed.length>0){
                   dispatch.customTemplates.setSelectedTemplateUsed(true);
                } else {
                    dispatch.customTemplates.setSelectedTemplateUsed(false);
                }
            } catch (error) {
                console.log("Error in checkTemplateInUse ",error)
                throw error;
            }
        },
        async deleteTemplateId(templateId, state){
            try {
                let data = {};
                data.accountId = state.app.selectedAccount._id;
                data.organizationId = state.app.selectedOrganisation.id;
                let template = await customTemplateActionService.remove(templateId);
                dispatch.customTemplates.fetchTemplates();
            } catch (error) {
                console.log("Error in deleting template by id ",error)
                throw error;
            }
        }
    }
}